function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { PercentLabel } from '../../../Products';
import { FundMinInvestment } from '../../../Products/ProductsTable/ProductRow/FundMinInvestment';
import { CellFund } from '../CellFund';
import { empty } from './empty';
import { MIN_PRODUCTS, getPlaceholdersQty } from './configs';
var getClass = function getClass(fund) {
  return fund.classes.find(function (_ref) {
    var id = _ref.id;
    return fund.id === id;
  });
};
var getFundFee = function getFundFee(fund, fee) {
  var fundClass = getClass(fund);
  if (!fundClass) return null;
  if (fundClass.fees.hasOwnProperty(fee)) {
    return fundClass.fees[fee];
  }
  return null;
};
export var getFeesRows = function getFeesRows(productType, funds, inPill, getSheetPath) {
  var emptyFeesRows = empty(getPlaceholdersQty(funds, MIN_PRODUCTS)).map(function () {
    return React.createElement(PercentLabel, {
      key: "mgr",
      value: null
    });
  });
  var feesRows = [[''].concat(_toConsumableArray(funds.map(function (fund, index) {
    return React.createElement(CellFund, {
      key: index,
      productType: productType,
      index: index + 1,
      getSheetPath: getSheetPath,
      fund: fund,
      onDeleteAction: function onDeleteAction() {},
      minimal: true
    });
  }))), ['Inversión mínima'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(FundMinInvestment, {
      key: "minInvestment",
      entity: fund,
      decimals: 0,
      params: {}
    });
  }))), ['Comisión de gestión'].concat(_toConsumableArray(funds.map(function (fund) {
    var fee = getFundFee(fund, 'mgr');
    return React.createElement(PercentLabel, {
      key: "mgr",
      value: fee ? fee.value : null,
      decimals: 3
    });
  }))), ['Comisión de depositaría'].concat(_toConsumableArray(funds.map(function (fund) {
    var fee = getFundFee(fund, 'cus');
    return React.createElement(PercentLabel, {
      key: "cus",
      decimals: 3,
      value: fee ? fee.value : null
    });
  }))), ['Comisión de éxito'].concat(_toConsumableArray(funds.map(function (fund) {
    var fee = getFundFee(fund, 'suc');
    return React.createElement(PercentLabel, {
      key: "suc",
      decimals: 3,
      value: fee ? fee.value : null
    });
  }))), ['Comisión de suscripción'].concat(_toConsumableArray(funds.map(function (fund) {
    var fee = getFundFee(fund, 'flo');
    return React.createElement(PercentLabel, {
      key: "flo",
      decimals: 3,
      value: fee ? fee.value : null
    });
  }))), ['Comisión de reembolso'].concat(_toConsumableArray(funds.map(function (fund) {
    var fee = getFundFee(fund, 'red');
    return React.createElement(PercentLabel, {
      key: "red",
      decimals: 3,
      value: fee ? fee.value : null
    });
  }))), ['Gastos corrientes'].concat(_toConsumableArray(funds.map(function (fund) {
    var fee = getFundFee(fund, 'ogc');
    return React.createElement(PercentLabel, {
      key: "ogc",
      decimals: 3,
      value: fee ? fee.value : null
    });
  })))];
  if (!inPill) {
    feesRows.map(function (fee) {
      return fee.push.apply(fee, _toConsumableArray(emptyFeesRows));
    });
  }
  return feesRows;
};